// dataType ที่ search-cc-manual รองรับ (นอกเหนือจากนี้ API ตอบ 400)
const DATA_TYPE_OPTIONS = [
  { value: "lsfhp", label: "บันชี 1" },
  { value: "vsfhp", label: "บันชี 2" },
  { value: "sfhp", label: "บันชี 8" },
  { value: "rpsl", label: "บันชี 3ใหม่" },
  { value: "psfhp", label: "บันชี 3เก่า" },
];

export default DATA_TYPE_OPTIONS;
